import React from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import Button from '../button';
import { stripLeadingSlash } from '../../utils/data/strings';
import config from '../../config';

interface Props {
  currentPage: number;
  totalPosts: number;
  className?: string;
}

interface PrevNextButtonsProps {
  hasPrevious: boolean;
  hasNext: boolean;
  previousUrl?: string;
  nextUrl?: string;
}

export const PrevNextButtons = ({
  hasPrevious,
  hasNext,
  previousUrl,
  nextUrl
}: PrevNextButtonsProps) => {
  let prev = null;
  let next = null;
  if (hasPrevious) {
    prev = (
      <Button className={cn({ 'mr-4': hasNext })} href={previousUrl}>
        Back
      </Button>
    );
  }

  if (hasNext) {
    next = (
      <Button className={cn({ 'ml-4': hasPrevious })} href={nextUrl}>
        Next
      </Button>
    );
  }

  return (
    <>
      {prev}
      {next}{' '}
    </>
  );
};

const Pagination = ({ className, currentPage, totalPosts }: Props) => {
  const router = useRouter();
  const { postsPerPage } = config;

  if (totalPosts < postsPerPage) {
    return null;
  }
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  const path = stripLeadingSlash(router.asPath);
  const currentPath = new URL(`${process.env.UI_URL!}/${path}`).pathname;
  const hasPrevious = currentPage > 1;
  const hasNext = currentPage < totalPages;

  const prevNext = (
    <PrevNextButtons
      hasPrevious={hasPrevious}
      previousUrl={`${currentPath}?page=${currentPage - 1}`}
      hasNext={hasNext}
      nextUrl={`${currentPath}?page=${currentPage + 1}`}
    />
  );

  return (
    <div className={cn('flex list-none justify-center', className)}>
      {prevNext}
    </div>
  );
};

export default Pagination;
